import { Routes } from '@angular/router';
import {
  authGuard,
  authMatchGuard,
  instructorCalendarGuard,
  instructorAppGuard,
  instructorAppMatchGuard,
  organisationWorkspaceGuard,
  organisationWorkspaceMatchGuard,
  rootGuard,
  rootMatchGuard,
  studentAppGuard,
  studentAppMatchGuard
} from './core/auth/auth.guard';
import { ResourceDetailsPageComponent } from './pages/resource-details/resource-details-page.component';
import { ContextEntryPageComponent } from './pages/context-entry/context-entry-page.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LoginPageComponent } from './pages/login/login-page.component';
import { PasswordCompletionPageComponent } from './pages/oauth/password-completion-page.component';
import { ResourceListPageComponent } from './pages/resource-list/resource-list-page.component';
import { UserManagementPageComponent } from './pages/context-entry/user-management-page.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginPageComponent },
  { path: 'activate-account', component: PasswordCompletionPageComponent },
  { path: 'reset-password', component: PasswordCompletionPageComponent },
  { path: 'context', component: ContextEntryPageComponent, canMatch: [rootMatchGuard], canActivate: [rootGuard] },
  {
    path: 'student',
    canMatch: [studentAppMatchGuard],
    canActivate: [studentAppGuard],
    loadChildren: () => import('./modules/student/student.routes').then((m) => m.STUDENT_ROUTES)
  },
  {
    path: 'instructor',
    canMatch: [instructorAppMatchGuard],
    canActivate: [instructorAppGuard],
    loadChildren: () => import('./modules/instructor/instructor.routes').then((m) => m.INSTRUCTOR_ROUTES)
  },
  { path: 'dashboard', component: DashboardComponent, canMatch: [authMatchGuard], canActivate: [authGuard] },
  { path: 'calendar/occupancy', canMatch: [authMatchGuard], canActivate: [authGuard, instructorCalendarGuard], loadComponent: () => import('./pages/organisation-occupancy/organisation-occupancy.component').then((m) => m.OrganisationOccupancyComponent) },
  {
    path: 'reports',
    canMatch: [authMatchGuard],
    canActivate: [authGuard],
    loadComponent: () => import('./pages/reports/reports.component').then((m) => m.ReportsComponent)
  },
  {
    path: 'notifications',
    canMatch: [authMatchGuard],
    canActivate: [authGuard],
    loadComponent: () => import('./pages/notifications/notifications.component').then((m) => m.NotificationsComponent)
  },
  { path: 'admin/users', component: UserManagementPageComponent, canMatch: [authMatchGuard], canActivate: [authGuard] },
  { path: 'admin', canMatch: [rootMatchGuard], canActivate: [rootGuard], loadChildren: () => import('./modules/root/root.routes').then((m) => m.ROOT_ROUTES) },
  { path: 'resources/:entityKey', component: ResourceListPageComponent, canMatch: [organisationWorkspaceMatchGuard], canActivate: [organisationWorkspaceGuard] },
  { path: 'resources/:entityKey/:id', component: ResourceDetailsPageComponent, canMatch: [organisationWorkspaceMatchGuard], canActivate: [organisationWorkspaceGuard] },
  { path: '**', redirectTo: '' }
];
